module.exports = __webpack_public_path__ + "png/feed.png?79e6a866f55893fd260912eef257ad33";